const API_URL = process.env.REACT_APP_API_URL;

// Допоміжна функція для обробки відповідей
async function handleResponse(res: Response) {
  if (!res.ok) {
    throw new Error(`Помилка API: ${res.status} ${res.statusText}`);
  }
  
  const text = await res.text();
  return text ? JSON.parse(text) : null; 
}

export const api = {
  getEmployees: async () => {
    const res = await fetch(`${API_URL}/employees`);
    return handleResponse(res);
  },

  getClinic: async () => {
    const res = await fetch(`${API_URL}/clinic`);
    return handleResponse(res);
  },

  getReviews: async () => {
    const res = await fetch(`${API_URL}/reviews`);
    return handleResponse(res);
  },

  createReview: async (data: any) => {
    const res = await fetch(`${API_URL}/reviews`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return handleResponse(res);
  },
  
  getNews: async () => {
    const res = await fetch(`${API_URL}/news`);
    return handleResponse(res);
  },

  getServices: async () => {
    const res = await fetch(`${API_URL}/services`);
    return handleResponse(res);
  }
};